import { connect } from 'react-redux';
import StepsDescription from './steps-description.component';
import { showRewardsImageLightbox } from '../friends-referral/friends-referral-store';
import { State } from 'widgets/friends-referral/root/root.reducers';

const mapStateToProps = (state: State) => ({
    imageSrc: state.config.friendsReferral?.rewardsImageSrc,
    isLightboxOpen: state.friendsReferral.rewardsImageLightboxOpened
});

const mapDispatchToProps = {
    showRewardsImageLightbox,
};

export default connect(mapStateToProps, mapDispatchToProps)(StepsDescription);
